import React from 'react';
import PropTypes from 'prop-types';
import Badge from './Badge';

const AlertCard = ({ 
  variant = 'info', // 'success' | 'warning' | 'error' | 'info'
  icon,
  title,
  description,
  badges = [],
  children,
  className = '',
  ...rest 
}) => {
  const variantConfig = {
    success: {
      containerClass: 'bg-gradient-to-br from-succession-bg-primary to-succession-bg-secondary border-succession-border',
      iconBgClass: 'bg-gradient-to-br from-emerald-500 to-teal-600',
      titleClass: 'text-succession-text-primary',
      descClass: 'text-succession-text-secondary',
      badgeVariant: 'success',
    },
    warning: {
      containerClass: 'bg-gradient-to-br from-succession-bg-primary to-succession-bg-secondary border-succession-border',
      iconBgClass: 'bg-gradient-to-br from-amber-500 to-orange-600',
      titleClass: 'text-succession-text-primary',
      descClass: 'text-succession-text-secondary',
      badgeVariant: 'warning',
    },
    error: {
      containerClass: 'bg-gradient-to-br from-succession-bg-primary to-succession-bg-secondary border-succession-border',
      iconBgClass: 'bg-gradient-to-br from-red-500 to-rose-600',
      titleClass: 'text-succession-text-primary',
      descClass: 'text-succession-text-secondary',
      badgeVariant: 'error',
    },
    info: {
      containerClass: 'bg-gradient-to-br from-succession-bg-primary to-succession-bg-secondary border-succession-border',
      iconBgClass: 'bg-gradient-to-br from-blue-500 to-indigo-600',
      titleClass: 'text-succession-text-primary',
      descClass: 'text-succession-text-secondary',
      badgeVariant: 'info',
    },
  };

  const config = variantConfig[variant] || variantConfig.info;
  const displayIcon = icon !== undefined ? icon : config.defaultIcon;

  return (
    <div 
      className={`border-2 rounded-3xl p-8 shadow-xl ${config.containerClass} ${className}`}
      {...rest}
    >
      <div className="text-center">
        
        {title && (
          <h3 className={`text-xl font-bold mb-2 ${config.titleClass}`}>
            {title}
          </h3>
        )}
        
        {description && (
          <p className={`leading-relaxed max-w-2xl mx-auto ${config.descClass} ${children || badges.length > 0 ? 'mb-4' : ''}`}>
            {description}
          </p>
        )}
        
        {badges.length > 0 && (
          <div className="mt-4 flex justify-center flex-wrap gap-2">
            {badges.map((badge, index) => (
              <Badge 
                key={index} 
                variant={badge.variant || config.badgeVariant}
                icon={badge.icon}
              >
                {badge.label}
              </Badge>
            ))}
          </div>
        )}
        
        {children && <div className="mt-4">{children}</div>}
      </div>
    </div>
  );
};

AlertCard.propTypes = {
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
  icon: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  badges: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    icon: PropTypes.node,
    variant: PropTypes.string,
  })),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default AlertCard;

